
//```import saga efects
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

//```import Error Manager
import { ExceptionManager } from 'Core/logManager';

//```import constants types
import {
    ACCOUNTS_EXPORT_LOGS_REQUEST,
    ACCOUNTS_EXPORT_SEARCH_USERS_REQUEST,
} from 'Redux/actionTypes';

import { endpoints } from 'Core/defaultValues';
import { accountsExportLogsResult, accountsExportSearchUsersResult } from 'Redux/actions';
import { clientMutation, clientQuery } from 'Core/data/GraphQLApi';

function* searchExportLogs({ payload }) {
    try {
        let QUERY = `
            query searchExportLogs ($accountId: Int!, $projectId: String, $dateRange: AWSDateTimeRange, $limit : Int, $nextToken: String, $userId: Int, $lastRecords: Int) {
                result: searchExportLogs (accountId: $accountId, projectId: $projectId, dateRange: $dateRange, limit: $limit, nextToken: $nextToken userId: $userId, lastRecords: $lastRecords) {
                    items {
                        id
                        accountId
                        authId
                        createdOn
                        errorMessage
                        name
                        outputURL
                        processedRecords
                        projectId
                        projectIdcreatedOn
                        status
                        statusUpdatedOn
                        total
                        ttl
                        type
                    }
                    nextToken
                }
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );

        if (data) {
            yield put(accountsExportLogsResult(data, payload.nextToken))
        }
    } catch (exc) {
        yield put(accountsExportLogsResult())
        ExceptionManager(
            exc,
            "Modules/accounts/.components/exportLogs/redux/saga",
            "searchExportLogs",
        )
    }
}

function* searchUsersByAccount({ payload }) {
    try {
        let QUERY = `
            query searchSubUsers ($conditions: [SubUserSearchInput], $sort: [SubUserSortInput], $limit: Int, $offset: Int) {
                result: searchSubUsers (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                    items {
                        id
                        userName
                    }
                    total
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                conditions: [
                    {
                        fields: ["companyId"],
                        terms: [payload],
                        exact: true,
                    }
                ],
                sort: {
                    field: "userName",
                    order: "DESC"
                },
                limit: 1000,
                offset: 0
            },
            endpoints.GRAPHQL_GENERAL,
        );
        if (data) {
            yield put(accountsExportSearchUsersResult(data.result.items || []))
        }
    } catch (exc) {
        yield put(accountsExportSearchUsersResult([]))
        ExceptionManager(
            exc,
            "Modules/accounts/.components/exportLogs/redux/saga",
            "searchUsersByAccount",
        )
    }
}

function* watchMethods() {
    yield takeEvery(ACCOUNTS_EXPORT_LOGS_REQUEST, searchExportLogs);
    yield takeEvery(ACCOUNTS_EXPORT_SEARCH_USERS_REQUEST, searchUsersByAccount);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}